import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { BodyText, Title, WarningBox, Button } from 'modules/styled';
import { CashoutFooter } from 'modules/wallet/web/cashoutFooter';
import { useWeb3React } from 'web3/hooks';
import { injected } from 'web3/connectors';

Web3Warning.propTypes = {
  connectAddress: PropTypes.func,
  warning: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
};

export default function Web3Warning({ connectAddress, warning }) {
  const { Component = WarningBox, message, title, buttonAction } = warning;
  const { activate } = useWeb3React();
  if (!warning) return null;

  const onClickCreator = () => {
    switch (buttonAction) {
      case 'connectMetamask':
        return () => activate(injected);
      case 'getMetamask':
        return () => window.open('https://metamask.io/', '_blank');
      case 'connectAddress':
        return () => connectAddress();
      default:
        return null;
    }
  };
  const onPress = onClickCreator();

  const customButton = onPress && (
    <Button disabled={warning.disabled} sx={{ mr: 'auto' }} onPress={onPress}>
      {warning.buttonText}
    </Button>
  );

  return (
    <Fragment>
      <Component>
        <Title>{title}</Title>
        <BodyText sx={{ mt: 2 }}>{message}</BodyText>
      </Component>
      <CashoutFooter customButton={customButton} />
    </Fragment>
  );
}
